import { FC } from 'react'
import ReactModal from 'react-modal'
import { Capacitor } from '@capacitor/core'
import { useDispatch } from 'react-redux'
import { closeModal } from 'store/actions/modals'
import { Button } from 'ui'

type ProfileImageZoomInModalProps = {
  size?: number
  pictureUrl: string | undefined
}

const ProfileImageZoomInModal: FC<ProfileImageZoomInModalProps> = ({ size = 350, pictureUrl }) => {
  const dispatch = useDispatch()

  return (
    <ReactModal
      isOpen
      overlayClassName={`map-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-map' : ''}`}
      shouldFocusAfterRender
      onRequestClose={() => dispatch(closeModal())}
      style={{
        content: {
          top: '50%',
          left: '50%',
          height: 'fit-content',
          width: 'fit-content',
          transform: 'translate(-50%, -50%)',
          padding: '2px 15px 15px 15px'
        }
      }}
    >
      <div className="d-flex justify-content-end">
        <Button className="close pb-2" aria-label="Close" onClick={() => dispatch(closeModal())}>
          <span aria-hidden="true">&times;</span>
        </Button>
      </div>
      <img src={`${pictureUrl}`} alt="Profile picture zoom in" style={{ objectFit: 'cover', width: size, height: size }} />
    </ReactModal>
  )
}

export default ProfileImageZoomInModal
